import styled, { createGlobalStyle } from 'styled-components';
import Icon from '@minecraft.icon';
import DropdownItem from '@minecraft.dropdown-item';
import Nav from '@minecraft.nav';
import { media, grid } from '@minecraft.themes';

type DropDownMenuItemMobileProps = {
  selected?: boolean;
};

type MenuItemMobileProps = {
  $selected?: boolean;
};

export const ArtistsListWrapper = styled.div`
  max-height: 50vh;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const RightIcon = styled(Icon)`
  font-size: 1rem;
  float: right;
  height: 10px;
  margin-top: 14px;
`;

export const ArtistInfo = styled.div`
  padding: 0;
  color: ${(props): string => props.theme.colors.primary.primary};
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  img {
    max-height: 2.5rem;
  }
`;

export const MobileArtistInfo = styled(ArtistInfo)`
  font-weight: 400;
`;

export const CurrentArtistInfo = styled(ArtistInfo)`
  min-width: 256px;
  border-radius: 4px;
  border-bottom: solid 1px ${(props): string => props.theme.colors.primary.ltGrey1};
  background-color: ${(props): string => props.theme.colors.primary.white};
  padding: 3px 16px;
  border: solid 1px ${(props): string => props.theme.colors.primary.ltGrey1};
  font-weight: bold;
`;

export const MenuItem = styled(DropdownItem)<DropDownMenuItemMobileProps>`
  min-width: 256px;
  padding: 0 0 0 0.25rem;
  border-bottom: solid 1px ${(props): string => props.theme.colors.primary.ltGrey1};
  background-color: ${(props): string => props.theme.colors.primary.white};
  font-weight: 500;
  font-size: 1rem;
  white-space: nowrap;
  height: 48px;
  line-height: 2.25rem;
  cursor: pointer;
  color: ${(props): string => props.theme.colors.primary.darkGrey}!important;
  &&&:active {
    background-color: ${(props): string => props.theme.colors.primary.white};
  }
  a {
    display: inline-block;
    padding: 0.25rem 1rem;
    height: 100%;
    width: 100%;
  }
  a:not(.active) {
    color: ${(props): string => props.theme.colors.primary.darkGrey}!important;
  }
  &:hover {
    background-color: ${(props): string => props.theme.colors.accent.ltGrey2};
  }
`;

export const MenuButton = styled(MenuItem)`
  padding: 0.25rem 1rem;
`;

export const MenuItemMobile = styled.div<MenuItemMobileProps>`
  padding: 0.25rem 0;
  background-color: ${(props): string =>
    props.$selected ? props.theme.colors.accent.ltGrey2 : props.theme.colors.primary.white};
  font-weight: 400;
  font-size: 1rem;
  white-space: nowrap;
  cursor: pointer;
  color: ${(props): string => props.theme.colors.primary.darkGrey};
  a {
    color: ${(props): string => props.theme.colors.primary.darkGrey}!important;
    display: inline-block;
    padding: 0.5rem 1rem;
    height: 100%;
    width: 100%;
  }
  &:hover {
    background-color: ${(props): string => props.theme.colors.accent.ltGrey2};
  }
  img {
    border-radius: 4px;
  }
`;

export const MenuButtonMobile = styled(MenuItemMobile)`
  padding: 0.5rem 1rem;
  height: auto;
`;

export const MainDropDownMenuItemMobile = styled(MenuItemMobile)`
  padding: 0.5rem 1rem;
  font-weight: 500;
  line-height: 2.25rem;

  svg {
    margin-top: 0.75rem;
  }
`;

export const DropDownMenuItemMobile = styled.div<DropDownMenuItemMobileProps>`
  padding: 0 1rem;
  margin-left: -1rem;
  margin-right: -1rem;
  background-color: ${(props): string =>
    props.selected ? props.theme.colors.accent.ltGrey2 : props.theme.colors.primary.white};
  font-weight: 400;
  font-size: 1rem;
  white-space: nowrap;
  min-height: 3rem;
  cursor: pointer;
  color: ${(props): string => props.theme.colors.primary.darkGrey};
  a {
    color: ${(props): string => props.theme.colors.primary.darkGrey}!important;
  }
  &:hover {
    background-color: ${(props): string => props.theme.colors.accent.ltGrey2};
  }
  .dropdown-menu {
    border: none;
    margin-top: 0 !important;
  }
  .dropdown {
    a {
      font-size: 1rem;
      font-weight: 500;
      color: ${(props): string => props.theme.colors.primary.darkGrey};
    }
  }
`;

export const SubMenuItems = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  transform: translateX(-100%);
  border: solid 1px ${(props): string => props.theme.colors.primary.ltGrey1};
  display: none;
`;

export const SubMenu = styled.div`
  position: relative;
  &:hover ${SubMenuItems} {
    display: block;
    margin-right: 0;
    margin-top: -1px;
  }
`;

export const StyledNav = styled(Nav)`
  margin-left: inherit !important;
  @media screen and (max-width: ${grid.breakpoints.xxlg}) {
    position: absolute;
    right: 1.875rem;
    top: 0.7rem;
  }
`;

export const NavAndButtonWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const NavGlobalStyle = createGlobalStyle`
  .navbar-light .navbar-nav {
    a.nav-link{
        color: ${(props): string => props.theme.colors.primary.primary};
        font-size: 0.875rem;
      &:hover {
        color:${(props): string => props.theme.colors.primary.black};
      }
    }
  }
  .navbar-nav{
    .dropdown.nav-item {
      .nav-link {
        padding:0;
      }
      .dropdown-menu{
        padding: 0;
        border-radius: 4px;
        margin-top: 0.5rem;
      }
      margin-right: 0;
      &.show  {
             ${CurrentArtistInfo} {
              border: solid 1px ${(props): string => props.theme.colors.primary.primary};
              color: ${(props): string => props.theme.colors.primary.darkGrey};
             }
          }
    }

    &>.dropdown.nav-item {
          margin-right: 0;
    }
  }
  .example {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.8s;
    &-entered {
      max-height: 100px;
    }
  }
`;

export const MobileCollapseMenuWrapper = styled.div`
  position: absolute;
  top: 4rem;
  left: 0;
  background: white;
  padding: 0 1rem;
  width: 100%;
  max-height: calc(100vh - 4rem);
  overflow: auto;
  ${media.sm`
     position: initial;
     overflow: initial;
  `}
`;

export const StyledUpdateLink = styled.a`
  &&& {
    text-decoration: none;
    &:hover {
      text-decoration: none;
    }
  }
`;
